<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  count?: number | string
  variant?: 'counter' | 'dot'
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'counter',
})

const shouldShowBadge = computed(
  () => props.variant === 'dot' || (props.count !== undefined && props.count !== null && Number(props.count) > 0),
)

const badgeClasses = computed(() => ({
  badge: true,
  'rounded-circle': true,
  'd-inline-flex': true,
  'align-items-center': true,
  'justify-content-center': true,
  'badge-primary text-white': props.variant === 'counter' || props.variant === 'dot',
  'counter-badge': props.variant === 'counter',
  'dot-badge': props.variant === 'dot',
}))
</script>

<template>
  <span v-if="shouldShowBadge" :class="badgeClasses">
    <slot>{{ count }}</slot>
  </span>
</template>

<style lang="scss" scoped>
.counter-badge {
  font-size: 11px;
  padding: 4px 7px;
  line-height: 1;
}

.dot-badge {
  position: absolute;
  width: 8px;
  height: 8px;
  top: 0;
  left: 0;
  transform: translate(-30%, -30%);
  padding: 0;
  z-index: 2;
}
</style>
